import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import GamesBanner from './components/GamesBanner';
import GlobalTestDataBanner from './components/GlobalTestDataBanner';
import Footer from './components/Footer';
import Login from './pages/Login';
import Register from './pages/Register';
import VerifyEmail from './pages/VerifyEmail';
import Dashboard from './pages/Dashboard';
import Roster from './pages/Roster';
import CreateLeague from './pages/CreateLeague';
import JoinLeague from './pages/JoinLeague';
import JoinInvite from './pages/JoinInvite';
import Account from './pages/Account';
import LeagueLayout from './components/LeagueLayout';
import LeaguePlayers from './pages/league/LeaguePlayers';
import LeagueFarm from './pages/league/LeagueFarm';
import LeagueScoreboard from './pages/league/LeagueScoreboard';
import LeagueMatchups from './pages/league/LeagueMatchups';
import LeagueStandings from './pages/league/LeagueStandings';
import LeagueSettings from './pages/league/LeagueSettings';
import CommissionerHub from './pages/league/CommissionerHub';
import LeagueHistory from './pages/league/LeagueHistory';
import TeamRoster from './pages/league/TeamRoster';
import DraftRoom from './pages/league/DraftRoom';
import { AuthProvider, useAuth } from './contexts/AuthContextAWS';
import { PlayerProfileProvider } from './contexts/PlayerProfileContext';
import { PlayerPopoverProvider } from './contexts/PlayerPopoverContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { TestDataBannerProvider } from './contexts/TestDataBannerContext';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <PlayerProfileProvider>
        <TestDataBannerProvider>
          <Router>
            <div className="App app-shell">
              <GlobalTestDataBanner />
              <Navbar />
              <main className="main-content">
                <div className="page-container">
                  <GamesBanner />
                  <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/verify-email" element={<VerifyEmail />} />
                    <Route path="/join-invite" element={<JoinInvite />} />
                    <Route path="/" element={<ProtectedRoute><div className="container"><Dashboard /></div></ProtectedRoute>} />
                    <Route path="/account" element={<ProtectedRoute><div className="container" style={{ paddingTop: '24px' }}><Account /></div></ProtectedRoute>} />
                    <Route path="/create-league" element={<ProtectedRoute><div className="container" style={{ paddingTop: '24px' }}><CreateLeague /></div></ProtectedRoute>} />
                    <Route path="/join-league" element={<ProtectedRoute><div className="container" style={{ paddingTop: '24px' }}><JoinLeague /></div></ProtectedRoute>} />

                    {/* League-specific routes */}
                    <Route path="/league/:leagueId" element={<ProtectedRoute><LeagueLayout /></ProtectedRoute>}>
                      {/* League home removed — default landing is My Roster */}
                      <Route index element={<Navigate to="roster" replace />} />
                      <Route path="home" element={<Navigate to="../roster" replace />} />
                      <Route path="roster" element={<Roster />} />
                      <Route path="players" element={<LeaguePlayers />} />
                      <Route path="farm" element={<LeagueFarm />} />
                      <Route path="draft" element={<DraftRoom />} />
                      <Route path="scoreboard" element={<LeagueScoreboard />} />
                      {/* Scoreboard page removed — redundant with Live Matchup */}
                      <Route path="matchups" element={<Navigate to="../scoreboard" replace />} />
                      <Route path="standings" element={<LeagueStandings />} />
                      <Route path="history" element={<LeagueHistory />} />
                      <Route path="settings" element={<LeagueSettings />} />
                      <Route path="commissioner" element={<CommissionerHub />} />
                      <Route path="team/:teamId/roster" element={<TeamRoster />} />
                    </Route>
                  </Routes>
                </div>
              </main>
            <Footer />
        </div>
      </Router>
        </TestDataBannerProvider>
        </PlayerProfileProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  
  if (loading) {
    return <div className="container">Loading...</div>;
  }
  
  if (!user) {
    return <Navigate to="/login" />;
  }
  
  return children;
}

export default App;
